import React from "react";

import * as S from "./styles";
import { TDSButton } from "./types";

const DSButton: React.FC<TDSButton> = ({
  fullWidth = false,
  isDisabled = false,
  isLoading = false,
  buttonType,
  isCancelType,
  height,
  buttonText,
  fontSize,
  icon,
  width,
  opacityOnHover,
  ...rest
}) => {
  return (
    <S.Button
      fullWidth={fullWidth}
      isDisabled={isDisabled}
      buttonType={buttonType}
      isCancelType={isCancelType}
      opacityOnHover={opacityOnHover}
      style={{
        height,
        width: fullWidth ? "100%" : width,
        fontSize,
      }}
      {...rest}
    >
      {isLoading && (
        <S.Loader buttonType={buttonType as "primary" | "secondary"} />
      )}{" "}
      {icon && !isLoading && icon}
      {buttonText}
    </S.Button>
  );
};

export default DSButton;
